/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Container, Spinner } from "react-bootstrap";
import useRoleSelect from "./useRoleSelect";
import "./RoleSelection.scss";
import { Carousel } from "antd";

export default (props) => {
  const {
    loading,
    onRoleSelectClick,
    onRoleChange,
    formInputsError,
    onSignOut,
  } = useRoleSelect(props);

  return (
    <div className="common-login role-selection-wrapper">
      <Container className="px-0">
        <div className="row no-gutters">
          <div className="col-lg-6 d-none d-md-block">
            <div className="left-img h-100">
              <div className="login-slider">
                <Carousel autoplay arrows>
                  <div className="slider-content">
                    <img
                      src="/assets/images/slider-img-1.svg"
                      alt="slider-img"
                      className="slider-img"
                    />
                    <h2 className="text-white mb-2">
                      Simplify Your Recruitment Process
                    </h2>
                    <p className="font-weight-medium text-white">
                      Make recruitment easy for businesses of all sizes.
                      Streamline your hiring process, from job posting to
                      candidate management, and discover the best-fit candidates
                      for your team with Jigsaw's innovative platform.
                    </p>
                  </div>
                  <div className="slider-content">
                    <img
                      src="/assets/images/slider-img-2.svg"
                      alt="slider-img"
                      className="slider-img"
                    />
                    <h2 className="text-white mb-2">
                      Rescue Hiring Manger & Candidate From Fate
                    </h2>
                    <p className="font-weight-medium text-white">
                      Don't leave recruitment process of hiring manager and
                      candidate’s career to fate. Take control with Jigsaw's
                      intuitive platform, designed to simplify recruitment and
                      elevate your professional growth. Say goodbye to
                      uncertainty and achieve your goals with Jigsaw.
                    </p>
                  </div>
                  <div className="slider-content">
                    <img
                      src="/assets/images/slider-img-3.svg"
                      alt="slider-img"
                      className="slider-img"
                    />
                    <h2 className="text-white mb-2">
                      Take Control of Your Career with Jigsaw!
                    </h2>
                    <p className="font-weight-medium text-white">
                      Unlock your full potential and achieve your career goals
                      with Jigsaw. Our intuitive platform empowers you with the
                      tools and resources you need to succeed, streamlined job
                      searching and interview preparation. Take control of your
                      future today with Jigsaw.
                    </p>
                  </div>
                </Carousel>
              </div>
            </div>
          </div>
          <div className="col-lg-6 ">
            <div className="form-wrapper py-5 h-100">
              <ul className="steps d-flex align-items-center justify-content-between mx-auto mb-4">
                <li className="step completed">
                  <span>1</span>
                </li>
                <li className="step">
                  <span>2</span>
                </li>
                <li className="step">
                  <span>3</span>
                </li>
              </ul>
              <h1 className="mb-2">How are you planning to use Jigsaw?</h1>
              <p className="h3 text-muted font-weight-normal mb-4">
                We’ll setup your experience accordingly
              </p>

              <form>
                <div className="form-group">
                  <label
                    htmlFor="CandidateSelection"
                    className="role-selection-check rounded-lg"
                  >
                    <input
                      type="radio"
                      name="roleSelection"
                      id="CandidateSelection"
                      className="d-none"
                      onClick={(e) => onRoleChange("candidate")}
                    />
                    <div className="content border rounded-lg p-3">
                      <img
                        src="/assets/images/candidate-icon.png"
                        alt="candidate icon"
                      />
                      <h4 className="text-primary mb-2 h5">Candidate</h4>
                      <p>
                        If you are currently seeking employment, you fall under
                        the category of Candidate.
                      </p>
                    </div>
                  </label>
                </div>

                {/* <div className="form-group">
                  <label
                    htmlFor="MentorSelection"
                    className="role-selection-check  rounded-lg"
                  >
                    <input
                      type="radio"
                      name="roleSelection"
                      id="MentorSelection"
                      className="d-none"
                      onClick={(e) => onRoleChange("mentor")}
                    />
                    <div className="content border rounded-lg p-3">
                      <img
                        src="/assets/images/halkboard-teacher-light.png"
                        alt="candidate icon"
                      />
                      <h4 className="text-primary mb-2 h5">Mentor</h4>
                      <p>
                        If you are an experienced professional who provides
                        guidance and support to others in your field, you may
                        fall under the category of Mentor.
                      </p>
                    </div>
                  </label>
                </div> */}

                {formInputsError.role && formInputsError.role.length > 0 ? (
                  <div className="form-group">
                    <span className="text-danger mt-1">
                      {formInputsError.role}
                    </span>
                  </div>
                ) : null}
                {formInputsError.formSubmitError &&
                formInputsError.formSubmitError.length > 0 ? (
                  <div className="form-group">
                    <span className="text-danger mt-1">
                      {formInputsError.formSubmitError}
                    </span>
                  </div>
                ) : null}

                <div className="d-flex align-items-center justify-content-between mt-4 mt-lg-5">
                  <button
                    className="btn btn-light"
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.reload(false);
                    }}
                  >
                    Back
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={(e) => {
                      e.preventDefault();
                      onRoleSelectClick();
                    }}
                  >
                    {loading ? (
                      <Spinner
                        animation="border"
                        variant=""
                        className="text-white"
                      />
                    ) : (
                      "Next"
                    )}
                  </button>
                </div>
                <p className="text-center mt-5">
                  Go back to website{" "}
                  <span className="text-primary" onClick={onSignOut}>
                    JIGSAW.
                  </span>
                </p>
              </form>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
